module.exports = __webpack_public_path__ + "img/icon-41.8766ca5c.svg";